module.exports = __webpack_public_path__ + "static/media/logo.0a72c9e3.svg";